<template>
  <section class="news">
    <h1 class="title">
      {{ Ltype }}
    </h1>
    <div class="list" :class="{ 'new-list': Ltype === '新闻报道' }">
      <!-- <label>年</label>
      <el-select v-model="value" size="medium" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="info">Filter</el-button> -->
      <div class="item">暂无数据</div>
      <!-- <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="toLink(item)"
      >
        <div class="date">{{ item.date }}</div>
        <div class="title">
          <a href="" target="_blank">{{ item.title }}</a>
        </div>
        <div class="content">{{ item.content }}</div>
      </div> -->
      <!-- <el-pagination
        layout="prev, pager, next"
        :total="page.total"
        :current-page.sync="page.currentPage"
        :page-size="page.pageSize"
        :pager-count="5"
        @current-change="changePage"
      >
      </el-pagination> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'news',
  props: {
    Ltype: {
      type: String,
      default: '新闻稿'
    }
  },
  data() {
    return {
      options: [
        {
          value: '2019',
          label: '2019'
        },
        {
          value: '2020',
          label: '2020'
        },
        {
          value: '2021',
          label: '2021'
        },
        {
          value: '2022',
          label: '2022'
        },
        {
          value: '2023',
          label: '2023'
        },
        {
          value: '2024',
          label: '2024'
        },
        {
          value: '2025',
          label: '2025'
        }
      ],
      list: [],
      page: {
        total: 10,
        pageSize: 3,
        currentPage: 1
      }
    }
  },
  created() {
    this.onQuery()
    if (this.Ltype === '新闻稿') {
      this.page.pageSize = 10
    }
    console.log(this.page)
  },
  methods: {
    onQuery() {
      if (this.Ltype === '新闻稿') {
        this.list = [
          {
            data: '2025年2月19日',
            title: 'Xport报告2024年第四季度和全年业绩',
            content:
              '以色列PETAH-TIKVA， 2025年2月19日（GLOBE NEWSWIRE）——推动全球直接面向消费者的电子商务平台Xport Online Ltd.（纳斯达克代码：GLBE）今天公布了2024年第四季度和2024年全年的财务业绩。“2024年是环球电子又一个破纪录的一年'
          },
          {
            data: '2025年2月6日',
            title: 'Xport将于2025年2月19日公布2024年第四季度和年底的财务业绩',
            content:
              '以色列peta - tikva， 2025年2月6日（GLOBE NEWSWIRE）——推动全球直接面向消费者的电子商务平台Xport（纳斯达克股票代码：GLBE）今天宣布，将在2月19日（周三）市场开盘前公布截至2024年12月31日的第四季度和全年财务业绩。'
          }
        ]
      } else if (this.Ltype === '新闻报道') {
        this.list = [
          {
            data: '2024年12月17日',
            title: '维多利亚的秘密选择Xport加强国际电子商务服务',
            content:
              'Xport将支持维密的主要国际市场，为100多个市场提供本地化的国际D2C解决方案。'
          },
          {
            data: '2024年12月17日',
            title: '维多利亚的秘密选择Xport加强国际电子商务服务',
            content:
              '全球直接面向消费者的电子商务平台Xport今天宣布，他们已被世界领先的内衣零售商维多利亚的秘密公司选中，以推进其国际在线业务。'
          },
          {
            data: '2024年12月17日',
            title: '维多利亚的秘密选择Xport Online来推进在线运营',
            content:
              'Xport（纳斯达克股票代码：GLBE）宣布，全球领先的内衣零售商Victoria’s Secret已选择其来推进其国际在线业务。'
          }
        ]
      }
    },
    toLink(item) {
      window.open(item.url)
    },
    changePage(e) { }
  }
}
</script>

<style scoped lang="less">
div,
p,
h1 {
  font-family: 'Open Sans', Sans-serif;
}
.news {
  padding-block-start: 150px;
  padding-block-end: 0;
  padding-top: 5%;
  margin: 0 auto;
  max-width: 1140px;

  .title {
    text-transform: capitalize;
    font-size: 36px;
    font-weight: 700;
    text-transform: ccapitalize;
    font-family: 'Poppins', Sans-serif;
    margin: 24px 0;
  }
  .list {
    max-height: 730px;
    overflow-y: auto;
    label {
      display: block;
      line-height: 26px;
      color: #333;
    }
    .el-select {
      width: 360px;
      margin-bottom: 20px;
    }
    .el-button--info {
      padding-bottom: 11px;
      margin-left: 16px;
      height: 36px;
      background-color: #f15a2b;
      border-color: #f15a2b;
    }
    .item {
      padding: 16px 10px;
      border-bottom: 1px solid #ececec;
      transition: all 0.3s;
      .date {
        font-size: 16px;
        color: #8f8f8f;
      }
      .title {
        font-size: 22px;
        font-weight: 600;
        line-height: 34px;
        margin: 0;
        a {
          color: #3b3e41;
        }
      }
      .content {
        padding: 11px 0;
        line-height: 19.2px;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .new-list {
    .item {
      padding: 30px 10px 15px;
      cursor: pointer;
      .content {
        max-width: 630px;
      }
    }
    .item:hover {
      background-color: #fbfbfc;
    }
  }
}
</style>
